import { defineStore } from 'pinia';
import { useGlobalStore } from '@/store/global-store-base';
import { useApi } from '@lib/api';
import { useUser } from '@/store/user';
import { useCompanies } from '@/store/companies';

export const useSampleRoundTypes = defineStore('sample-round-types', () => {
  const api = useApi();
  const globalStoreBase = useGlobalStore({
    load: api.sampleRoundType_ListTypes,
    dto: 'SampleRoundTypeDto',
    create: api.sampleRoundType_AddType,
    update: api.sampleRoundType_UpdateType,
    delete: api.sampleRoundType_DeleteType,
    usage: api.sampleRoundType_GetSampleRoundTypeUsage,
    signalR: 'SampleRoundTypeUpdate',
  });

  async function uploadTemplates(typeId: number, files: File[]) {
    const brandId = useUser().brandId;
    await api.sampleRoundType_UploadTemplates(brandId, typeId, files);
  }

  async function deleteTemplate(typeId: number, templateId: number) {
    const brandId = useUser().brandId;
    await api.sampleRoundType_DeleteTemplate(brandId, typeId, templateId);
  }

  async function updateTemplate(
    typeId: number,
    templateId: number,
    args: { name: string; summaryFileFormat: number; isFavorite: boolean }
  ) {
    const brandId = useUser().brandId;
    return await api.sampleRoundType_UpdateTemplate(brandId, typeId, templateId, args);
  }

  async function uploadStaticFiles(typeId: number, files: File[]) {
    const brandId = useUser().brandId;
    const uploaded = await Promise.all(
      files.filter((file) => file.size > 0).map((file) => useCompanies().uploadFileIncludeSizeAndName(file))
    );
    await api.sampleRoundType_AttachStaticFiles(brandId, typeId, { files: uploaded });
  }

  async function deleteStaticFile(typeId: number, fileId: number) {
    const brandId = useUser().brandId;
    await api.sampleRoundType_DeleteStaticFile(brandId, typeId, fileId);
  }

  async function updateStaticFile(typeId: number, fileId: number, args: { name: string; isFavorite: boolean }) {
    const brandId = useUser().brandId;
    return await api.sampleRoundType_UpdateStaticFile(brandId, typeId, fileId, args);
  }

  return {
    ...globalStoreBase,
    uploadTemplates,
    deleteTemplate,
    updateTemplate,
    uploadStaticFiles,
    deleteStaticFile,
    updateStaticFile,
  };
});
